export default __webpack_public_path__ + "static/lu2020-a79b033a20afaa047b67b2e1ff6b1596.jpg";